import { useState, useEffect } from "react";

const payMethods = ["微信支付", "支付宝", "银行卡", "现金", "银行代扣", "网银转账"];
const payMethodIcons: Record<string, string> = {
  "微信支付": "ri-wechat-pay-line",
  "支付宝": "ri-alipay-line",
  "银行卡": "ri-bank-card-line",
  "现金": "ri-money-cny-circle-line",
  "银行代扣": "ri-bank-line",
  "网银转账": "ri-exchange-dollar-line",
};
const payMethodColors: Record<string, string> = {
  "微信支付": "text-green-600 bg-green-50",
  "支付宝": "text-cyan-600 bg-cyan-50",
  "银行卡": "text-blue-600 bg-blue-50",
  "现金": "text-amber-600 bg-amber-50",
  "银行代扣": "text-purple-600 bg-purple-50",
  "网银转账": "text-indigo-600 bg-indigo-50",
};

const initialRecords = [
  { id: "PAY20260410001", user: "张建国", userId: "R001", amount: 200, method: "微信支付", time: "14:32:15", status: "成功", type: "购气充值" },
  { id: "PAY20260410002", user: "北京华联超市", userId: "C002", amount: 5000, method: "银行代扣", time: "14:28:42", status: "成功", type: "月度结算" },
  { id: "PAY20260410003", user: "王大明", userId: "R003", amount: 100, method: "支付宝", time: "14:25:08", status: "成功", type: "购气充值" },
  { id: "PAY20260410004", user: "老北京涮肉馆", userId: "C001", amount: 2000, method: "网银转账", time: "14:20:33", status: "成功", type: "欠费补缴" },
  { id: "PAY20260410005", user: "陈小红", userId: "R004", amount: 50, method: "现金", time: "14:15:22", status: "成功", type: "购气充值" },
  { id: "PAY20260410006", user: "刘建华", userId: "R005", amount: 300, method: "银行卡", time: "14:10:55", status: "成功", type: "购气充值" },
  { id: "PAY20260410007", user: "赵美丽", userId: "R006", amount: 150, method: "微信支付", time: "14:05:18", status: "失败", type: "购气充值" },
  { id: "PAY20260410008", user: "北京燃气热力", userId: "C003", amount: 15000, method: "银行代扣", time: "13:58:44", status: "成功", type: "月度结算" },
];

const newPayments = [
  { user: "孙志远", userId: "R007", amount: 200, method: "微信支付", type: "购气充值" },
  { user: "周晓燕", userId: "R008", amount: 500, method: "支付宝", type: "购气充值" },
  { user: "北京协和医院", userId: "C004", amount: 8000, method: "银行代扣", type: "月度结算" },
  { user: "李秀梅", userId: "R002", amount: 100, method: "现金", type: "欠费补缴" },
];

interface Props {
  onStatsUpdate?: (total: number, count: number) => void;
}

export default function FeeRealtimeRecords({ onStatsUpdate }: Props) {
  const [records, setRecords] = useState(initialRecords);
  const [filterMethod, setFilterMethod] = useState("全部");
  const [newRecordFlash, setNewRecordFlash] = useState<string | null>(null);
  const [batchModal, setBatchModal] = useState(false);
  const [batchRunning, setBatchRunning] = useState(false);
  const [batchProgress, setBatchProgress] = useState(0);
  const [batchDone, setBatchDone] = useState(false);
  const [payModal, setPayModal] = useState(false);
  const [payForm, setPayForm] = useState({ user: "", amount: "", method: "微信支付", type: "购气充值" });
  const [paySuccess, setPaySuccess] = useState(false);

  // Simulate real-time new records
  useEffect(() => {
    let idx = 0;
    const timer = setInterval(() => {
      if (idx >= newPayments.length) { idx = 0; }
      const np = newPayments[idx];
      const now = new Date();
      const timeStr = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
      const newRec = {
        id: `PAY${Date.now()}`,
        user: np.user,
        userId: np.userId,
        amount: np.amount,
        method: np.method,
        time: timeStr,
        status: "成功",
        type: np.type,
      };
      setRecords(prev => [newRec, ...prev.slice(0, 19)]);
      setNewRecordFlash(newRec.id);
      setTimeout(() => setNewRecordFlash(null), 2000);
      if (onStatsUpdate) {
        setRecords(prev => {
          const total = prev.filter(r => r.status === "成功").reduce((s, r) => s + r.amount, 0);
          onStatsUpdate(total, prev.filter(r => r.status === "成功").length);
          return prev;
        });
      }
      idx++;
    }, 8000);
    return () => clearInterval(timer);
  }, [onStatsUpdate]);

  const handleBatch = () => {
    setBatchRunning(true);
    setBatchProgress(0);
    const timer = setInterval(() => {
      setBatchProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setBatchRunning(false);
          setBatchDone(true);
          return 100;
        }
        return prev + 5;
      });
    }, 100);
  };

  const handleManualPay = () => {
    if (!payForm.user || !payForm.amount) return;
    const now = new Date();
    const timeStr = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
    const newRec = {
      id: `PAY${Date.now()}`,
      user: payForm.user,
      userId: "MANUAL",
      amount: parseFloat(payForm.amount),
      method: payForm.method,
      time: timeStr,
      status: "成功",
      type: payForm.type,
    };
    setRecords(prev => [newRec, ...prev]);
    setNewRecordFlash(newRec.id);
    setPaySuccess(true);
    setTimeout(() => {
      setPayModal(false);
      setPaySuccess(false);
      setPayForm({ user: "", amount: "", method: "微信支付", type: "购气充值" });
    }, 1500);
  };

  const filtered = records.filter(r => filterMethod === "全部" || r.method === filterMethod);
  const todayTotal = records.filter(r => r.status === "成功").reduce((s, r) => s + r.amount, 0);

  return (
    <div className="space-y-3">
      {/* Realtime header */}
      <div className="bg-white rounded-xl border border-gray-100 p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse inline-block"></span>
            <span className="text-sm font-semibold text-gray-800">实时收费记录</span>
            <span className="text-xs text-gray-400">今日已收 {records.filter(r => r.status === "成功").length} 笔</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-right">
              <div className="text-lg font-bold text-[#E8531A]">¥{todayTotal.toLocaleString()}</div>
              <div className="text-[10px] text-gray-400">今日收款总额</div>
            </div>
            <button
              onClick={() => setPayModal(true)}
              className="flex items-center gap-1.5 bg-[#E8531A] text-white px-3 py-2 rounded-lg text-xs cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line"></i>手动收费
            </button>
            <button
              onClick={() => setBatchModal(true)}
              className="flex items-center gap-1.5 border border-gray-200 text-gray-600 px-3 py-2 rounded-lg text-xs cursor-pointer whitespace-nowrap hover:bg-gray-50"
            >
              <i className="ri-bank-line"></i>批量代扣
            </button>
          </div>
        </div>

        {/* Payment method filter */}
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs text-gray-400">支付方式：</span>
          {["全部", ...payMethods].map(m => (
            <button
              key={m}
              onClick={() => setFilterMethod(m)}
              className={`px-2.5 py-1 rounded-full text-xs cursor-pointer whitespace-nowrap transition-colors ${filterMethod === m ? "bg-[#E8531A] text-white" : "bg-gray-100 text-gray-500 hover:bg-gray-200"}`}
            >
              {m !== "全部" && <i className={`${payMethodIcons[m]} mr-1`}></i>}
              {m}
            </button>
          ))}
        </div>
      </div>

      {/* Records table */}
      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              {["流水号", "用户", "金额", "支付方式", "类型", "时间", "状态"].map(h => (
                <th key={h} className="text-left text-xs font-medium text-gray-500 px-4 py-3">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {filtered.map(rec => (
              <tr
                key={rec.id}
                className={`transition-all ${newRecordFlash === rec.id ? "bg-green-50" : "hover:bg-gray-50"}`}
              >
                <td className="px-4 py-3 text-[10px] font-mono text-gray-400">{rec.id.slice(-8)}</td>
                <td className="px-4 py-3">
                  <div className="text-xs font-medium text-gray-800">{rec.user}</div>
                  <div className="text-[10px] text-gray-400">{rec.userId}</div>
                </td>
                <td className="px-4 py-3 text-sm font-bold text-gray-800">¥{rec.amount.toLocaleString()}</td>
                <td className="px-4 py-3">
                  <span className={`flex items-center gap-1 text-xs px-2 py-0.5 rounded-full w-fit ${payMethodColors[rec.method] || "text-gray-600 bg-gray-50"}`}>
                    <i className={`${payMethodIcons[rec.method] || "ri-money-cny-circle-line"} text-xs`}></i>
                    {rec.method}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-gray-600">{rec.type}</td>
                <td className="px-4 py-3 text-xs text-gray-500 font-mono">{rec.time}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${rec.status === "成功" ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600"}`}>
                    {rec.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Batch deduction modal */}
      {batchModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => !batchRunning && setBatchModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[480px]" onClick={e => e.stopPropagation()}>
            <h3 className="text-base font-bold text-gray-900 mb-4">批量银行代扣</h3>
            {batchDone ? (
              <div className="text-center py-6">
                <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-check-double-line text-green-500 text-3xl"></i>
                </div>
                <div className="text-base font-bold text-gray-900">批量代扣完成！</div>
                <div className="text-sm text-gray-500 mt-1">成功代扣 23 户，金额 ¥18,650</div>
                <button onClick={() => { setBatchModal(false); setBatchDone(false); setBatchProgress(0); }} className="mt-4 bg-[#E8531A] text-white px-6 py-2 rounded-lg text-sm cursor-pointer whitespace-nowrap">
                  确认
                </button>
              </div>
            ) : (
              <>
                <div className="bg-gray-50 rounded-xl p-4 mb-4">
                  <div className="grid grid-cols-3 gap-3 text-center">
                    {[
                      { label: "待代扣用户", value: "23户" },
                      { label: "代扣总金额", value: "¥18,650" },
                      { label: "预计成功率", value: "95%" },
                    ].map((s, i) => (
                      <div key={i}>
                        <div className="text-base font-bold text-gray-800">{s.value}</div>
                        <div className="text-xs text-gray-400">{s.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                {batchRunning ? (
                  <div>
                    <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                      <span>正在执行批量代扣...</span>
                      <span>{batchProgress}%</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div className="bg-[#E8531A] h-2 rounded-full transition-all" style={{ width: `${batchProgress}%` }} />
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div>
                      <label className="text-xs text-gray-500 mb-1 block">代扣范围</label>
                      <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                        <option>欠费超过30天的用户</option>
                        <option>欠费超过60天的用户</option>
                        <option>余额低于50元的用户</option>
                        <option>全部签约代扣用户</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-xs text-gray-500 mb-1 block">代扣金额</label>
                      <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                        <option>按欠费金额全额代扣</option>
                        <option>固定金额 ¥100</option>
                        <option>固定金额 ¥200</option>
                        <option>固定金额 ¥500</option>
                      </select>
                    </div>
                    <div className="flex gap-2">
                      <button onClick={() => setBatchModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2 rounded-lg text-sm cursor-pointer whitespace-nowrap">取消</button>
                      <button onClick={handleBatch} className="flex-1 bg-[#E8531A] text-white py-2 rounded-lg text-sm cursor-pointer whitespace-nowrap">确认执行代扣</button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* Manual pay modal */}
      {payModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setPayModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[420px]" onClick={e => e.stopPropagation()}>
            {paySuccess ? (
              <div className="text-center py-6">
                <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-check-double-line text-green-500 text-3xl"></i>
                </div>
                <div className="text-base font-bold text-gray-900">收费成功！</div>
              </div>
            ) : (
              <>
                <h3 className="text-base font-bold text-gray-900 mb-4">手动收费</h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">用户姓名/单位</label>
                    <input
                      value={payForm.user}
                      onChange={e => setPayForm(p => ({ ...p, user: e.target.value }))}
                      placeholder="请输入用户名称"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]"
                    />
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">收费金额（元）</label>
                    <input
                      type="number"
                      value={payForm.amount}
                      onChange={e => setPayForm(p => ({ ...p, amount: e.target.value }))}
                      placeholder="0.00"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]"
                    />
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">支付方式</label>
                    <div className="grid grid-cols-3 gap-2">
                      {payMethods.map(m => (
                        <button
                          key={m}
                          onClick={() => setPayForm(p => ({ ...p, method: m }))}
                          className={`flex items-center gap-1.5 px-2 py-2 rounded-lg text-xs border cursor-pointer whitespace-nowrap transition-colors ${payForm.method === m ? "border-[#E8531A] bg-orange-50 text-[#E8531A]" : "border-gray-200 text-gray-600"}`}
                        >
                          <i className={`${payMethodIcons[m]} text-sm`}></i>
                          {m}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">收费类型</label>
                    <select
                      value={payForm.type}
                      onChange={e => setPayForm(p => ({ ...p, type: e.target.value }))}
                      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]"
                    >
                      <option>购气充值</option>
                      <option>欠费补缴</option>
                      <option>月度结算</option>
                      <option>安检费用</option>
                      <option>开户费用</option>
                    </select>
                  </div>
                  <div className="flex gap-2 pt-1">
                    <button onClick={() => setPayModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2 rounded-lg text-sm cursor-pointer whitespace-nowrap">取消</button>
                    <button onClick={handleManualPay} className="flex-1 bg-[#E8531A] text-white py-2 rounded-lg text-sm cursor-pointer whitespace-nowrap">确认收费</button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
